import { nanoid } from "nanoid";
import { useRef } from "react";

/**
 * ID which persists between renders, for use with connecting HTML elements for accessibility purposes
 */
export const useHtmlId = () => {
  const id = useRef(nanoid());

  return id.current;
};
